import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
// @mui
import { Box, Typography } from "@mui/material";
//
import { StyledItem, StyledIcon } from "./styles";
import colors from "../../../config/colors";
import { subRouteLink } from "../../../utils/routeLinks";
// ga
import { triggerGa, CATEGORY, ACTION } from "../../../utils/gaUtils";

// ----------------------------------------------------------------------

NavItem.propTypes = {
  open: PropTypes.bool,
  active: PropTypes.bool,
  item: PropTypes.object,
  depth: PropTypes.number,
};

export default function NavItem({ item, depth, open, active, ...other }) {
  const navigate = useNavigate();

  const { label, path, icon, disabled } = item;

  const handleClick = () => {
    const page = path?.replace(/^\//, "");
    const screenName = item?.routes?.[0]?.path;
    triggerGa({
      category: CATEGORY.NAVIGATION,
      action: ACTION.BUTTON_CLICK,
      label: label,
      page: page,
      screenName: screenName,
    });

    // subRouteLink drops a trailing optional param ("home/:tab?"), so this lands on the
    // section's default page instead of pushing the literal ":tab?" text into the URL.
    const pathToNavigate = screenName ? subRouteLink(path, screenName) : path;
    if (pathToNavigate) {
      navigate(pathToNavigate);
    }
  };

  return (
    <Box onClick={handleClick} data-cy={`nav-item-${label}`}>
      <StyledItem active={active} disabled={disabled} {...other}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          {icon && <StyledIcon active={active}>{icon}</StyledIcon>}
          <Typography
            variant="caption"
            sx={{
              color: active ? colors.primary500 : "white",
              textAlign: "center",
              mt: "4px",
              fontWeight: 500,
              fontSize: "10px",
              lineHeight: 1.2,
            }}
          >
            {label}
          </Typography>
        </Box>
      </StyledItem>
    </Box>
  );
}
